import {
  changeFieldValue,
  setQuestionVisibility,
  getQuestion,
} from 'app/services/businessFunctionHelpers';
import { getConsentsValues } from 'app/shared/helpers/getConsentsValues';
import { getIsMubiLeasingConfig } from 'app/shared/helpers/getIsMubiLeasingConfig';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const insurantConsents = {
  onInsuranceMarketingConsentChange(initialRun: boolean) {
    const { mainConsentValue } = getConsentsValues();
    const isMubiLeasing = getIsMubiLeasingConfig();

    setQuestionVisibility({
      key: FieldsEnum.InsuranceMarketingEmailConsent,
      visible: !mainConsentValue,
      formName: FormsEnum.CalculationForm,
    });

    if (!mainConsentValue) {
      changeFieldValue(
        FieldsEnum.ButtonConsentsCalculation,
        false,
        FormsEnum.CalculationForm
      );
    }

    if (isMubiLeasing) {
      const buttonConsentsMubiLeasing = getQuestion(
        FieldsEnum.ButtonConsentsMubiLeasing,
        FormsEnum.CalculationForm
      );

      if (buttonConsentsMubiLeasing) {
        const shouldShowButton = !mainConsentValue;
        setQuestionVisibility({
          key: FieldsEnum.ButtonConsentsMubiLeasing,
          visible: shouldShowButton,
          formName: FormsEnum.CalculationForm,
        });
      }

      const consentMjm = getQuestion(
        FieldsEnum.ConsentMjm,
        FormsEnum.CalculationForm
      );
      const consentMjm2 = getQuestion(
        FieldsEnum.ConsentMjm2,
        FormsEnum.CalculationForm
      );

      if (consentMjm && consentMjm2) {
        if (mainConsentValue) {
          setQuestionVisibility({
            key: FieldsEnum.ConsentMjm,
            visible: false,
            formName: FormsEnum.CalculationForm,
          });
          setQuestionVisibility({
            key: FieldsEnum.ConsentMjm2,
            visible: true,
            formName: FormsEnum.CalculationForm,
          });
        } else {
          setQuestionVisibility({
            key: FieldsEnum.ConsentMjm,
            visible: true,
            formName: FormsEnum.CalculationForm,
          });
          setQuestionVisibility({
            key: FieldsEnum.ConsentMjm2,
            visible: false,
            formName: FormsEnum.CalculationForm,
          });
        }
      }
    }
  },
};

export default insurantConsents;
